import PropTypes from "prop-types";
import { Box, Drawer, List, Paper } from "@mui/material";
import { lazy, useEffect, useState } from "react";

import { useUserData } from "src/context/userContext";

import MyDivider from "src/components/layout/MyDivider";
import GlobalDrawer_LogoutListItem from "./ListItems/GlobalDrawer_LogoutListItem";
import GlobalDrawer_KäyttäjäListItem from "./ListItems/GlobalDrawer_KayttajaListItem";
import GlobalDrawer_DarkModeListItem from "./ListItems/GlobalDrawer_DarkModeListItem";
import GlobalDrawer_AsiakasListItem from "./ListItems/GlobalDrawer_AsiakasListItem";
import GlobalSearchListItemText from "./ListItems/search/GlobalSearchListItemText";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import SiteAppBarNavigationIcons from "src/components/layout/siteAppBar/components/SiteAppBarNavigationIcons";
import GlobalDrawer_ExtendedViewListItem from "./ListItems/search/GlobalDrawer_ExtendedViewListItem";

const GlobalDrawer_HinnastotListItem = lazy(() =>
  import("./ListItems/GlobalDrawer_HinnastotListItem")
);
const GlobalDrawer_TarjouksetListItem = lazy(() =>
  import("./ListItems/GlobalDrawer_TarjouksetListItem")
);

export default function GlobalDrawer(props) {
  const { auth } = useUserData();
  const fontSize = "26px";

  const [drawerIsOpen, setDrawerIsOpen] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setDrawerIsOpen(newOpen);
    props.onClose();
  };

  useEffect(() => {
    setDrawerIsOpen(props.open);
  }, [props.open]);

  const closeDrawer = () => {
    setDrawerIsOpen(false);
    props.onClose();
  };

  const list = () => (
    <Box sx={{ width: 300 }} role="presentation">
      <div style={{ height: 30, border: "1px solid gray" }}>
        <div className="center">
          <b>BETONI.ONLINE</b>
        </div>
      </div>
      <div className="spaceAround" style={{ paddingTop: 20, opacity: 0.8 }}>
        <SiteAppBarNavigationIcons size="large" onClick={props.onClose} />
      </div>
      <MyDivider />
      <LazyLoader>
        <List>
          <MyDivider />
          {auth.page.userAsiakas.read && (
            <>
              <GlobalDrawer_AsiakasListItem />
              <MyDivider />
            </>
          )}
          {auth.page.user.read && <GlobalDrawer_KäyttäjäListItem onClick={closeDrawer} />}
          <GlobalDrawer_DarkModeListItem />
          {auth.is.systemAdmin && <GlobalDrawer_ExtendedViewListItem />}
          <MyDivider />
          {auth.page.haku.read && <GlobalSearchListItemText onClick={closeDrawer} />}
          {auth.page.admin.read && (
            <>
              <GlobalDrawer_TarjouksetListItem fontSize={fontSize} />
              <GlobalDrawer_HinnastotListItem onClick={closeDrawer} />
            </>
          )}
          <MyDivider />
          {auth.page.user.read && (
            <Paper>
              <GlobalDrawer_LogoutListItem fontSize={fontSize} />
            </Paper>
          )}
        </List>
      </LazyLoader>
    </Box>
  );

  return (
    <>
      <Drawer anchor="right" open={drawerIsOpen} onClose={toggleDrawer(false)}>
        {list()}
      </Drawer>
    </>
  );
}
GlobalDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
